/**
 * This Component represents the Casting creation process.
 * the casting creation process doesnt differ from the pool creation process in the selection of models.
 * NOTE: what if you give the option to make the casting also a pool when creating it.
 */
import ModelSelection from "../ModelSelection";

const CreateCasting = ({ onBack, poolId = null, pool = {}, pools = [] }) => {
  

  return (
        <ModelSelection onBack={onBack} poolId={poolId} pool={pool} pools={pools} isPoolCreation={false}/>
  );
};

export default CreateCasting;
